module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-admin-versioning"
  }, [_c('AdminTools'), _vm._v(" "), _c('h1', {}, [_vm._v(_vm._s(_vm.$t("versioning.title")))]), _vm._v(" "), (_vm.canEdit) ? _c('Versioning', {
    ref: "cmpVersion"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-button"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.addVersionning
    }
  }, [_vm._v(_vm._s(_vm.$t("versioning.add")))])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/admin-tools"
    }
  }, [_vm._v("Retour à l'administration")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive content-vertionings table-size"
  }, [_c('table', {
    staticClass: "table table-hover  table-outlined"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.$t("versioning.version")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("versioning.name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("versioning.date")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("versioning.description")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("versioning.createBy")))]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.getVersionings), function(versioning, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticClass: "table-title"
    }, [_vm._v(_vm._s(versioning.version))]), _vm._v(" "), _c('td', {
      staticClass: "table-title"
    }, [_vm._v(_vm._s(versioning.name ? versioning.name.toUpperCase() : ""))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(versioning.versioningDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(versioning.description))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.getValueObject(versioning.createdUser, "firstname", "") + " " + _vm.getValueObject(versioning.createdUser, "lastname", "")) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "content-action"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.displayVersioning(versioning);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("versioning.edit")))]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.removeVersioning(versioning);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("versioning.remove")))])])])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-442942da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/versioning/VersioningList.vue
// module id = 3149
// module chunks = 0